import styled from "styled-components";
import { Widget } from "../../../../../components/widget";

export const StyledWidget = styled(Widget)`
  margin-top: 1em;
`;
